/** "Has a value" / "No value" picks in a field filter — never a real value, so they can't
 * collide with an imported one. Pure module (no React Native) so filter helpers can be tested. */
export const HAS_VALUE_SENTINEL = '__dislix_has_value__';
export const NO_VALUE_SENTINEL = '__dislix_no_value__';

/** Field filters (field → picked values) → the API's JSON customFieldFilters param;
 * undefined when nothing is picked, so callers can omit the param. */
export function buildCustomFieldFiltersParam(filters: Record<string, string[]>): string | undefined {
  const entries = Object.entries(filters)
    .filter(([, values]) => values.length > 0)
    .map(([key, values]) => {
      if (values.includes(HAS_VALUE_SENTINEL)) return { key, hasValue: true };
      if (values.includes(NO_VALUE_SENTINEL)) return { key, hasValue: false };
      return { key, values };
    });
  return entries.length > 0 ? JSON.stringify(entries) : undefined;
}
